module.exports = __webpack_public_path__ + "static/media/single-portfolio-1.12c0d92f.jpg";